import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';

import ClientLeadSettingsData from './ClientLeadSettingsData';
import ClientLeadSettingsDrawer from './ClientLeadSettingsDrawer';


const ClientLeadSettings = (props) => {
  const showSettings = props.showSettings;
  const openDrawerView = props.openDrawerView;
  const setOpenDrawerView = props.setOpenDrawerView;

  return (
    <>
      {
        !showSettings &&
        <Box sx={{width: '23vw', maxWidth: '296px', position: 'sticky', top: 16}}>
          <ClientLeadSettingsData
            {...props}
          />
        </Box>
      }
      {
        openDrawerView &&
        <ClientLeadSettingsDrawer
          settingsDrawerOpen={openDrawerView}
          setSettingsDrawerOpen={setOpenDrawerView}
        >

          <ClientLeadSettingsData
            {...props}
          />
        </ClientLeadSettingsDrawer>
      }
    </>
  );
};

ClientLeadSettings.propTypes = {
  showSettings: PropTypes.bool.isRequired,
  openDrawerView: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientLeadSettings));
